export default __webpack_public_path__ + "static/media/2002.e1ebd45e.png";